import { RequestStatuses } from 'content-management-data-lib';

// "Loading" here refers to when a loading indicator is shown, not if a request is in flight
const LOADING_STATUSES = [RequestStatuses.PENDING, RequestStatuses.UNINITIALIZED];
export const requestStatusLoading = status => LOADING_STATUSES.includes(status);